import { render } from "./bank-transfer.vue?vue&type=template&id=5d020185"
import script from "./bank-transfer.vue?vue&type=script&lang=js"
export * from "./bank-transfer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/resources/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__